import { KLAGE_ILEGGELSE_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageIleggelseimageReducers = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, KLAGE_ILEGGELSE_IMAGE);

export default klageIleggelseimageReducers;
